import Vue from 'vue'
import Router from 'vue-router'
import {getCookie} from 'common/js/mUtils'

const Login = () => import('components/login/login')
const LoginAfter = () => import('components/login/loginAfter')
const CustomerOrder = () => import('components/customerOrder/customerOrder')
const LabOrder = () => import('components/labOrder/labOrder')

Vue.use(Router)

const routersList = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/loginAfter',
    name: 'loginAfter',
    component: LoginAfter,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/customerOrder',
    name: 'customerOrder',
    component: CustomerOrder,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/labOrder',
    name: 'labOrder',
    component: LabOrder,
    meta: {
      requireAuth: true
    }
  }
]
const router = new Router({
  mode: 'hash',
  routes: routersList,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let token = getCookie('u_uuid_token')
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js